import React from "react"
import Subnav from "./subnav"
import { graphql, useStaticQuery } from "gatsby"

const DataServices = props => {
  const data = useStaticQuery(graphql`
    {
      services: allServicesJson {
        edges {
          node {
            id
            slug
            title
            image {
              childImageSharp {
                fluid(maxWidth: 800) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    }
  `)
  const contents = data.services.edges

  return <Subnav data={contents} tag={props.tag} slide={props.slide} />
}

export default DataServices
